import React, { Component, PropTypes } from 'react'
import { fromJS } from 'immutable'
import AdminNavbar from '../../components/AdminNavbar'
import styled from 'styled-components'
import { searchCountries } from '../../sources/SearchSource'
import { deleteCountry } from '../../sources/AdminSource'
import { translate } from 'react-i18next'
import CardContainer from '../../components/CardContainer'
import Trash from '../../svg-icons/Trash'
import Input from '../../components/Input'
import ThemeContainer from '../../components/ThemeContainer'
import { Metrics, Fonts } from '../../Themes'
import ErrorModal from '../../components/Modal/ErrorModal'
import DialogModal from '../../components/Modal/DialogModal'

const CustomCardContainer = styled(CardContainer)`
  margin-top: ${Metrics.margins.base};
`

const Container = styled.div`
  overflow-y: scroll;
  max-height: ${Metrics.components.adminContent};
`

const List = styled.div`margin-top: ${Metrics.margins.base};`

const Name = styled.div`${Fonts.style.Label};`

const ThrashContainer = styled.div`
  position: absolute;
  right: 0;
  top: ${Metrics.margins.base};
`

const Country = styled.div`
  border-bottom: ${Metrics.borders.default};
  height: 50px;
  cursor: pointer;
  padding: 18px 0;
  position: relative;
`

const SearchContainer = styled.div`
  border-bottom: ${Metrics.borders.defaultBorder};
  height: 50px;
`

const CustomThemeContainer = styled(ThemeContainer)`
  padding-left: ${Metrics.components.customThemeSpacing} !important;
  padding-right: ${Metrics.components.customThemeSpacing} !important;
`

class AdminCountries extends Component {
  constructor (props) {
    super(props)
    this.state = {
      countries: [],
      countryToDelete: null,
      name: '',
      modal: false
    }
    this.handleChange = this.handleChange.bind(this)
    this.handleDelete = this.handleDelete.bind(this)
    this.fetchCountries = this.fetchCountries.bind(this)
    this.toggleModal = this.toggleModal.bind(this)
  }

  shouldComponentUpdate (nextProps, nextState) {
    const { name, modal, countries, countryToDelete } = this.state
    if (
      name !== nextState.name ||
      modal !== nextState.modal ||
      !fromJS(nextState.countries).equals(fromJS(countries)) ||
      countryToDelete !== nextState.countryToDelete
    ) {
      return true
    }
    return false
  }

  componentWillMount () {
    this.fetchCountries()
  }

  handleChange (event) {
    this.setState({ name: event.target.value }, () => {
      searchCountries({
        where: {
          name: {
            startsWith: this.state.name
          }
        },
        sort: 'name ASC'
      })
        .then(response => this.setState({ countries: response.data }))
        .catch(error => console.log(error))
    })
  }

  fetchCountries () {
    searchCountries({ sort: 'name ASC' })
      .then(response => this.setState({ countries: response.data }))
      .catch(error => console.log(error))
  }

  handleDelete () {
    deleteCountry(this.state.countryToDelete.id)
      .then(response => {
        this.setState({ modal: false, name: '' }, () => this.fetchCountries())
      })
      .catch(error => {
        console.log(error)
        this.toggleModal('error')
      })
  }

  toggleModal (modal) {
    this.setState({ modal })
  }

  render () {
    const { t, admin, dropdownLinks, router } = this.props
    const { name, countries, modal } = this.state
    return (
      <div>
        <AdminNavbar
          admin={admin}
          fixedSearchBar
          dropdownLinks={dropdownLinks}
          rightSideActions={[
            {
              label: t('Create Country'),
              secondary: true,
              onClick: () => router.push(`/admin/locations/countries/new`)
            }
          ]}
        />
        <ErrorModal
          visible={modal === 'error'}
          message={t('There was a problem when deleting a country')}
          closeAction={() => this.toggleModal(false)}
          header={t('Error')}
        />
        <DialogModal
          visible={modal === 'dialog'}
          message={t('Do you want to delete this country?')}
          closeAction={() => this.toggleModal(false)}
          buttons={{
            apply: { label: t('Delete'), onClick: this.handleDelete },
            cancel: {
              label: t('Cancel'),
              onClick: () => this.toggleModal(false)
            }
          }}
        />
        <Container>
          <CustomThemeContainer>
            <CustomCardContainer title={t('Countries')}>
              <SearchContainer>
                <Input
                  handleChange={this.handleChange}
                  value={name}
                  placeholder={t('Search for countries')}
                />
              </SearchContainer>
              <List>
                {countries &&
                  countries.length > 0 &&
                  countries.map((country, index) => {
                    return (
                      <Country
                        key={`country-${country.name}-${index}`}
                        onClick={() =>
                          router.push(
                            `/admin/locations/countries/${country.id}`
                          )}>
                        <Name>{country.name}</Name>
                        <ThrashContainer>
                          <Trash
                            onClick={event => {
                              event.stopPropagation()
                              this.setState({
                                countryToDelete: country,
                                modal: 'dialog'
                              })
                            }}
                          />
                        </ThrashContainer>
                      </Country>
                    )
                  })}
              </List>
            </CustomCardContainer>
          </CustomThemeContainer>
        </Container>
      </div>
    )
  }
}

AdminCountries.propTypes = {
  t: PropTypes.func,
  router: PropTypes.object,
  admin: PropTypes.object,
  dropdownLinks: PropTypes.array
}

export default translate([ 'common', 'admin' ], { wait: true })(AdminCountries)



// WEBPACK FOOTER //
// ./src/pages/AdminLocations/AdminCountries.js